import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UserIdentifyService } from '@app/core/services/user-identify.service';
import { environment } from '@env';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { UtilsService } from '@src/app/core/services/utils.service';
import { PageCacheService } from '@src/app/features/search/services/page-cache.service';
import { RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { LoggerModule } from 'ngx-logger';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import {
  AppConfig,
  AzureADModule,
  Configuration,
  ConfigModule as SigvConfigModule,
  CoreModule as SigvCoreModule,
  LayoutModule as SigvLayoutModule,
  PresetModule as SigvPresetModule,
  initAppConfig,
} from 'sigv-library';
import { Configuration as RbacApiConfig } from 'src/app/api-info/system-management-api/configuration';
import { HttpErrorInterceptorWebsubmission } from 'src/app/core/interceptors/http-error-interceptor-websubmission';
import { version } from 'src/environments/version';
import { ApiModule } from './api-info/system-management-api';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import {
  TODO_DATA_PROVIDERS,
  TodoMenuItemProcessor,
} from './core/services/menu-processor.service';
import { NOTIFICATION_INFO_TRANSFORMERS } from './core/services/notification-info-handler.service';
import { ExtranetModule } from './extranet/extranet.module';
import { WebsubmissionMenuItemProcessor } from './features/services/websubmission-menu-item-processor.service';
import { WebsubmissionNitificationInfoTransformer } from './features/services/websubmission-nitification-info-transformer.service';
import { CommonService } from './features/web-submission/service/common.service';
import { LayoutModule } from './layout/layout.module';

export function HttpLoaderFactory(
  httpBackend: HttpBackend
): MultiTranslateHttpLoader {
  // 載入專案各別的語系檔與共用 library 語系檔
  return new MultiTranslateHttpLoader(new HttpClient(httpBackend), [
    { prefix: './assets/i18n/', suffix: '.json?v' + Date.now() },
    { prefix: './assets/i18n/sigv-library/', suffix: '.json?v' + Date.now() },
    { prefix: './assets/i18n/override.', suffix: '.json?v' + Date.now() },
  ]);
}

function configurationFactoryRbac(userIdentifyService?: any): RbacApiConfig {
  // const storage = localStorage.getItem('___upF_______') || sessionStorage.getItem('___upF_______');
  // const userProfile: UserProfile | undefined = JSON.parse( storage ?? '{}');
  // const isExtra =  (
  //   configuration.systemGroupCode === 'WebSubmission' &&
  //   configuration.isExtranet &&
  //   userProfile?.extranetUserRole === 0
  // );
  // let rbacApiInfoUrl='';
  // if(isExtra === true){
  //   rbacApiInfoUrl = url?.env?.apiSalesUrl.rbac.replace('/Rbac','');
  // }else{
  //   rbacApiInfoUrl = url?.env?.apiUrl.rbac.replace('/Rbac','');
  // }

  // return new RbacApiConfig({
  //   basePath: rbacApiInfoUrl
  // });
  const rbacConfig: RbacApiConfig = userIdentifyService.getRbacConfig();
  return rbacConfig
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
    LoggerModule.forRoot({
      level: environment.logLevel,
      colorScheme: ['gray', 'green', 'blue', 'gray', 'orange', 'red', 'purple'],
    }),
    CoreModule,
    SigvConfigModule.forRoot(
      new Configuration({
        env: environment.env,
        systemGroupCode: 'WebSubmission',
        systemCodes: [],
        isExtranet: environment.isExtranet,
        isErrorToastTrace: !environment.isExtranet,
        initMenu: false,
      })
    ),
    SigvCoreModule,
    SigvPresetModule,
    SigvLayoutModule,
    AzureADModule,
    LayoutModule,
    ExtranetModule,
    ApiModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled:
        location.protocol.startsWith('https') ||
        (environment.production &&
          ['localhost', '127.0.0.1'].includes(location.hostname)),
      registrationStrategy: 'registerImmediately',
    }),
  ],
  providers: [
    MessageService,
    DialogService,
    PageCacheService,
    UtilsService,
    CommonService,
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initAppConfig,
      deps: [AppConfig],
      multi: true,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'en',
    },
    {
      provide: RbacApiConfig,
      useFactory: configurationFactoryRbac,
      deps: [UserIdentifyService],
    },
    {
      provide: NOTIFICATION_INFO_TRANSFORMERS,
      useClass: WebsubmissionNitificationInfoTransformer,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorWebsubmission,
      multi: true,
    },
    {
      provide: TODO_DATA_PROVIDERS,
      useClass: WebsubmissionMenuItemProcessor,
      multi: true,
    },
    {
      provide: TODO_DATA_PROVIDERS,
      useClass: TodoMenuItemProcessor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    if (environment.env === 'SIT' || environment.env === 'UAT') {
      if (version.revision && version.branch) {
        console.log('\n');
        console.group('********** Build info **********');
        console.log(`Version:${version.revision}`);
        console.log(`Branch:${version.branch}`);
        console.log(`Updated Date:${version.updatedDate}`);
        console.groupEnd();
        console.log('\n');
      }
    }
  }
}
